<template>
  <div id="channelPacket">
    <el-main v-loading="isLoading" element-loading-text="loading" element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.1)">
      <template>
        <div class="header_p">部署扫码客户端</div>

        <div class="channel_conent">

          <div class="zip_channel">
            <p class="title_head">部署扫码客户端方法</p>
            <div class="thing2">
              <div class="header_p">1.下载扫码客户端</div>
              <div style="margin-bottom:10px">
                <a v-bind:href="package_download_url" class="scanning" ref="down">
                  <el-button type="goon" size="medium">立即下载</el-button>
                </a>
              </div>
              <p style="color:#F56C6C;">客户端为一个7z压缩包，下载完成后需解压</p>
              <div class="header_p" style="margin-top: 20px;">2.启动客户端</div>
              <div style="font-size: 14px;margin-bottom: 5px;">方式一：</div>
              <p style="margin-bottom: 10px;">下载配置文件<span style="color:#F56C6C;margin-bottom: 5px;">（文件名必须为client.txt）</span>，并放到步骤1解压后的目录中</p>
              <div>
                <el-button type="goon" size="medium" @click="downloadClientTxt(client)">立即下载配置文件</el-button>
              </div>
              <div style="font-size: 14px;margin: 20px 0 5px 0;">方式二：</div>
              <p style="margin-bottom: 10px;">命令行带渠道号直接启动</p>
              <p style="margin-bottom: 10px;">进入到解压后的根目录，命令行执行命令：</p>
              <p style="color:#F56C6C;">./外服扫码版.exe channel_number={{ch}}</p>
            </div>
          </div>
        </div>
      </template>
    </el-main>
  </div>
</template>

<script>
  import * as sysApi from "../common/sys";
  export default {
    name: "channelPacket",
    data() {
      return {
        isLoading: true,
        ch: "",
        package_download_url: "",
        client: ""
      };
    },
    created() {
      sysApi
        .qrcode_config()
        .then(res => {
          if(res.code === 200) {
            this.ch = res.data.ch;
            this.package_download_url = res.data.url;
            this.client = res.data.sign;
            this.isLoading = false;
          }
        })
        .catch(err => console.log("请求异常信息:" + err));
    },
    methods: {
      downloadClientTxt(content, filename = "client.txt") {
        const blob = new Blob([content], { type: "text/plain" });
        const link = document.createElement("a");

        link.href = URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);

        link.click();
        document.body.removeChild(link);
      },
    }
  };
</script>

<style scoped lang="scss">
  .title_img {
    width: 800px;
    height: 500px;
  }

  .explain {
    padding-top: 20px;
    color: #39c2b8;
    font-weight: bold;
    padding-right: 50px;
    font-size: 16px;
  }

  .addd {
    position: relative;
  }

  .switvch {
    position: absolute;
    top: 40px;
    left: 40%;
  }

  .scanning {
    // background: #6692ff;
    // line-height: 40px;
    // padding-left: 20px;
  }

  .alldown_package {
    margin-top: 20px;
    font-size: 16px;

    span {
      color: #5f95cc;
    }
  }

  .channel_conent {
    // border: 1px solid #bbbbbb;

    .zip_channel {
      // border-bottom: 1px solid #bbbbbb;
      background-color: #fff;
      margin-bottom: 30px;
      padding: 30px 20px;

      .title_head {
        margin: 0;
        line-height: 20px;
        font-size: 16px;
        color: #535353;
        margin-bottom: 20px;
      }

      .thing2 {
        padding: 0;
      }

      // padding-bottom: 70px;
    }
  }

  .header_p {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 20px;
    color: #535353;
  }


  .all_price span {
    font-size: 22px;
    font-weight: bold;
    color: #000;
  }

  .headerData,
  .alldown {
    div {
      position: relative;

      img {
        position: absolute;
        top: 10px;
        left: 8px;
        width: 20px;
        height: 20px;
      }
    }
  }

  #ul_firest li {
    flex: 3;
  }


  .thing,
  .thing2 {
    overflow: hidden;
    padding-left: 50px;
    padding-bottom: 10px;

  }

  .thing {
    position: relative;

    img {
      position: absolute;
      top: 10px;
      left: 60px;
      width: 20px;
      height: 20px;
    }
  }

  .thing a {
    // float: left;

    // color: #fff;
    // width: 180px;
    // text-align: center;
    // border-radius: 0px;
    // padding: 10px 20px;

    // margin-right: 40px;
  }

  .thing2 a {
    // color: #fff;
    // width: 180px;
    // text-align: center;
    // margin-bottom: 10px;
    // border-radius: 0px;
    // padding: 10px 20px;

  }

  .thing .download_span {
    float: left;
    color: #000;
    border-radius: 0px;
    padding: 10px 20px;
    margin-right: 40px;
  }

  .thing>li {
    float: left;
    margin: 5px 10px;
    list-style: none;
    padding: 10px;
    cursor: pointer;
    border-bottom: 1px solid #eee;
    background: #fff;

    color: #666;
  }

  .thing>li>a {
    color: #666;
  }

  .thing>li>a>p {
    overflow: hidden;
  }

  .thing>li>a>p>span:nth-child(1) {
    float: left;
  }

  .thing>li>a>p>span:nth-child(2) {
    float: right;
    color: #ff0000;
  }

  .fun>li {
    float: left;
    list-style: none;
    margin-right: 15px;
  }
</style>